import { createContext, useContext } from 'react';

/**
 * Provides the active (debounced) search term to all descendants so
 * cell renderers can highlight matching text via `useDataTableSearch()`.
 */
export const DataTableSearchContext = createContext<string>('');

/** Returns the debounced search term active in the nearest DataTable. */
export function useDataTableSearch(): string {
  return useContext(DataTableSearchContext);
}
